import {reverseGeocoding} from "@containers/reverseGeocoding/api";
import {
    buildDefaultPointMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/points/helpers/buildDefaultPointMutateSingleVoyage";
import {buildNameReverseGeocoding} from "@containers/reverseGeocoding/helpers/buildNameReverseGeocoding";
import {buildAddressReverseGeocoding} from "@containers/reverseGeocoding/helpers/buildAddressReverseGeocoding";
import {getPointGeomCoordinatesFromLatLng} from "@helpers/geoJson/getPointGeomCoordinatesFromLatLng";
import {useCallback, useState} from "react";
import {
    useRebuildPointsAndPositionsMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/points/hooks/useRebuildPointsAndPositionsMutateSingleVoyage";
import {
    useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";
import {OnAddPointMutateSingleVoyage} from "@containers/singleVoyage/mutateVoyage/points/types/events";

export function useAddPointActionMutateSingleVoyage(): {
    onAddPoint: OnAddPointMutateSingleVoyage
    isLoading: boolean
} {

    const [isLoading, setIsLoading] = useState(false)

    const {
        onRebuild,
        isPending,
    } = useRebuildPointsAndPositionsMutateSingleVoyage()

    const {
        points,
        setTargetPointId,
    } = useRootContextMutateSingleVoyage()

    const onAddPoint: OnAddPointMutateSingleVoyage = useCallback(async (latLng: { lat: number, lng: number }) => {
        setIsLoading(true)
        try {
            const res = await reverseGeocoding({
                lat: latLng.lat,
                lon: latLng.lng
            })
            const newPoint = buildDefaultPointMutateSingleVoyage({
                name: buildNameReverseGeocoding(res),
                address: buildAddressReverseGeocoding(res) ?? '...',
                geom: getPointGeomCoordinatesFromLatLng({
                    lat: latLng.lat,
                    lng: latLng.lng,
                }),
            })
            await onRebuild({
                points: [
                    ...points,
                    newPoint
                ]
            })
            setTargetPointId(newPoint.id?.toString())
            setIsLoading(false)
        } catch (e) {
            setIsLoading(false)
        }
    }, [points])

    return {
        isLoading: isLoading || isPending,
        onAddPoint
    }
}